import styled from "@alethio/ui/lib/styled-components";

export const ModuleContainer = styled.div`
    position: relative;
`;
